import { urlValidarSesion } from "../constants/urls";
import { FetchPost } from "../redux/actions/api";

const onValidarSesionActiva = async (fechaUltimoAcceso, estalogueado) => {
  if (estalogueado && estalogueado === true) {
  
    let resp = await FetchPost({
      url: urlValidarSesion,
      param: {
        empresa: "AIGMETROPOLITANA",
        fechaUltimoAcceso: fechaUltimoAcceso,
      },
    });
    const { transaccion, desloguear } = resp;
    if (transaccion && transaccion === true) {
      if (desloguear && desloguear === true) {
        //let host = window.location.hostname;
        window.location.href = "/logout";
      }
    }
  }
};

const cronSesion = () => {
  const serializedState = JSON.parse(localStorage.getItem("state"));
  const fecha = serializedState.datosUsuarios.dataUsuario.fechaUltimoAcceso;
  const estalogueado = serializedState.datosUsuarios.dataUsuario.userIsLoggedIn;
  onValidarSesionActiva(fecha, estalogueado);
};

export default cronSesion;
